// 
// App.js
// cenit-website
// 
// Created by Matías Martínez on 21/8/25
// 

import HighlighterEffect from "./HighlighterEffect";
import TickerAnimator from "./TickerAnimator";
import ContentReadiness from "./ContentReadiness";

class DocumentStateClassName {
  static js = "js";
  static done = "done";
  static firstImagesDone = "first-images-done";
}

class App {
  
  constructor(document){
    this.appendDocumentClassName(DocumentStateClassName.js);
    document.addEventListener("DOMContentLoaded", this.awake.bind(this));
  }
  
  appendDocumentClassName(name){
    document.documentElement.classList.add(name);
  }
  
  async awake(){
    const readiness = new ContentReadiness(document);
    await readiness.waitForAllFonts();
    
    this.appendDocumentClassName(DocumentStateClassName.done);
    
    await readiness.waitForAnimationsInElement(document.body);
    
    this.addEffects();
    
    await readiness.waitForImagesInElement(document.querySelector(".tidbits"));
    
    this.appendDocumentClassName(DocumentStateClassName.firstImagesDone);
  }
  
  addEffects(){
    // Highlighter effects:
    const highlightable = document.querySelectorAll("[data-highlighter] em")
    
    const animate = async () => {
      for (const node of [ ...highlightable]) {
        const effect = new HighlighterEffect({ node });
        await effect.animate();
      }
    };
    
    window.requestAnimationFrame(animate);
    
    // Ticker effect for tidbits:
    const animatableByTicker = document.querySelectorAll(".tidbits .items");
    this.animators = [ ...animatableByTicker ].map(node => new TickerAnimator({ node }));
  }
  
}

export default App;
